import { createPopper } from '@popperjs/core';

export default class Menu {

	constructor(element) {
		this.element = element;
		this.itemsWithChildren = (this.element instanceof HTMLElement) ? this.element.querySelectorAll('.menu-item-has-children') : undefined;
	}

	init() {
		this.initItemsWithChildren();
	}

	initItemsWithChildren() {
		if (this.itemsWithChildren) {
			this.itemsWithChildren.forEach(item => {
				this.initItemSubmenu(item);
			});
		}
	}

	initItemSubmenu(item) {
		const submenu = item.querySelector( '.sub-menu');
		submenu.setAttribute('data-menu-item-id', item.id);
		const arrow = this.appendArrow(submenu);
		const { placement, fallbackPlacements } = this.getPlacement(item);
		const instance = createPopper(item, submenu, {
			placement: placement,
			strategy: 'fixed',
			modifiers: [
				{
					name: 'flip',
					options: {
						fallbackPlacements: fallbackPlacements,
					},
				},
				{
					name: 'preventOverflow',
					options: {
						mainAxis: true,
						altAxis: true,
					},
				},
				{
					name: 'arrow',
					options: {
						element: arrow,
					},
				},
			],
		});
		instance.forceUpdate();
		submenu.gigsPopperInstance = instance;
	}

	getPlacement(item) {
		if (item instanceof HTMLElement) {
			if (item.parentElement.classList.contains('menu')) {
				return {
					placement: 'bottom',
					fallbackPlacements: ['top'],
				};
			} else {
				return {
					placement: 'right-start',
					fallbackPlacements: ['left-start'],
				};
			}
		}
		return {
			placement: 'auto',
			fallbackPlacements: ['auto'],
		};
	}

	appendArrow(submenu) {
		const arrow = document.createElement('i');
		arrow.setAttribute('data-popper-arrow', true);
		submenu.appendChild(arrow);
		return arrow;
	}
}

